<script>
	import Recommendation from './Recommendation.svelte'
	import { fade } from 'svelte/transition';
	export let recommendations
</script>

<div class="recommendations" transition:fade>
	{#each recommendations as recommendation}
		<Recommendation class="recommendation" {recommendation}/>
	{/each}
</div>

<style>
	.recommendations {
		/*padding: 1rem;*/
		display: columns;
		margin: auto;
	}
	.recommendation {
		/*margin-bottom: 0.5rem;*/
		width:  max-content;
	}
	@media screen and (min-width:720px) {
		.recommendations {
			column-count: 2;
		}
	}
</style>